type RecurrenceEditorShowReasonName =
  | 'seriesEditing'
  | 'assistantMissing'
  | 'disabledForm'
  | 'disabledPlannedTimes'
  | 'disableForBundles'
  | 'disabledForBundleAssistanceChild'
  | 'hasRecurrenceParent'
type RecurrenceEditorShowReason = {
  name: RecurrenceEditorShowReasonName
  compareValue: boolean
  currentValue: boolean
}

export class RecurrenceEditorShowStatus {
  showStatus: boolean = true

  // If currentValue==compareValue, showStatus should be true. So every reason should be written in the form that true = contributes to showing, false = contributes to not showing.
  private reasons: RecurrenceEditorShowReason[] = [
    { name: 'seriesEditing', compareValue: true, currentValue: true },
    { name: 'assistantMissing', compareValue: true, currentValue: true },
    { name: 'disabledForm', compareValue: false, currentValue: false },
    { name: 'disabledPlannedTimes', compareValue: false, currentValue: false },
    {
      name: 'disabledForBundleAssistanceChild',
      compareValue: false,
      currentValue: false,
    },
    { name: 'disableForBundles', compareValue: false, currentValue: false },
    { name: 'hasRecurrenceParent', compareValue: false, currentValue: false },
  ]

  constructor() {}

  setReason(reason: RecurrenceEditorShowReasonName, state: boolean): boolean {
    console.log('RecurrenceEditorShowStatus setReason', reason, state, this.reasons, this.showStatus)

    this.reasons.find((r) => r.name === reason).currentValue = state

    this.computeShowStatus()

    return this.showStatus
  }

  private computeShowStatus() {
    this.showStatus = this.reasons.every((r) => r.compareValue === r.currentValue)
    console.log('RecurrenceEditorShowStatus computeShowStatus', this.showStatus)
  }
}
